import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type RedirectionUrlState = string | null

export const redirectionUrlSlice = createSlice({
  name: 'redirectionUrl',
  initialState: null as RedirectionUrlState,
  reducers: {
    setRedirectionUrl: (state: RedirectionUrlState, action: PayloadAction<string>) => {
      return action.payload
    },
  },
})

export const { setRedirectionUrl } = redirectionUrlSlice.actions
